import { useEffect, useState } from 'react';
import { layout } from '@theme/theme.layout';

// Converts text align value to flex
const convertAlignToFlex = (alignment) => {
  return alignment
    ? alignment === 'left'
      ? 'flex-start'
      : alignment === 'center'
      ? 'center'
      : 'flex-end'
    : 'center';
};

// Parses flex position value (e.g. "flex-start center") into two values
const parseContentPosition = (position) => {
  return position
    ? position.split(' ').reduce((obj, pos, index) => {
        index === 0 ? (obj.alignItems = pos) : (obj.justifyContent = pos);
        return obj;
      }, {})
    : {};
};

// Adds horizontal padding to a specific element when parent section is full bleed
const pxWithFullBleed = (section) => {
  const isFullBleedMb = section?.mobile?.container === 'container';
  const isFullBleedDt = section?.desktop?.container === 'container';

  return {
    px: [
      isFullBleedMb ? layout.header?.px?.[0] || 0 : 0,
      isFullBleedDt ? layout.header?.px?.[1] || 0 : 0,
      isFullBleedDt ? layout.header?.px?.[2] || null : 0,
      isFullBleedDt ? layout.header?.px?.[3] || null : 0,
    ],
  };
};

const calcResponsiveHeight = ({ maxHeight, viewport }) => {
  if (!maxHeight || !viewport) return null;
  if (typeof maxHeight !== 'number' || typeof viewport !== 'number') {
    console.log('maxHeight and viewport must be integers');
    return null;
  }
  return `${maxHeight / (viewport / 100)}vw`;
};

const handleize = (string) => {
  let handleizedValue;

  if (string) {
    handleizedValue = string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  return handleizedValue;
};

export {
  convertAlignToFlex,
  parseContentPosition,
  pxWithFullBleed,
  calcResponsiveHeight,
  handleize,
};
